export enum Role {
  Learner = 'LEARNER',
  Educator = 'EDUCATOR',
  Administrator = 'ADMINISTRATOR',
  Partner = 'PARTNER',
  SimXUser = 'SIMX_USER',
  SimXEditor = 'SIMX_EDITOR',
  SimXSales = 'SIMX_SALES',
  SimXAdministrator = 'SIMX_ADMINISTRATOR',
  SimXSuperAdministrator = 'SIMX_SUPER_ADMINISTRATOR',
}
